<template>
  <div class="card card-style">
				<div class="content">
           <PuSkeleton :count="parseInt(count)" />
        </div>
  </div>
</template>

<script>
export default {
  props: ['count']
};
</script>